import React from 'react';
import LOGO from '../assets/logo.jpeg';

const LogoLoader = ({ text = 'Loading...' }) => {
  return (
    <div className="w-full flex justify-center py-10">
      <div className="flex flex-col items-center">

        {/* Logo with rotating border */}
        <div className="relative h-28 w-28 flex items-center justify-center">
          
          {/* Rotating ring */}
          <div className="absolute inset-0 rounded-full border-4 border-[#2F5DA8]/30 border-t-[#2F5DA8] animate-spin"></div>

          {/* Logo */}
          <img
            src={LOGO}
            alt="Logo"
            className="h-24 w-24 object-contain rounded-full bg-white"
          />
        </div>

        {/* Loading text */}
        <p className="mt-4 text-sm font-medium text-[#2F5DA8]">
          {text}
        </p>
      </div>
    </div>
  );
};

export default LogoLoader;
